import { render, staticRenderFns } from "./navBar.vue?vue&type=template&id=2c4d053e&scoped=true&"
import script from "./navBar.vue?vue&type=script&lang=js&"
export * from "./navBar.vue?vue&type=script&lang=js&"
import style0 from "./navBar.vue?vue&type=style&index=0&id=2c4d053e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d053e",
  null
  
)

export default component.exports